<template>
  <div id="app">
    <div>ΔLn：<el-input v-model="l" placeholder="" /></div>
    <div>E：<el-input v-model="e" placeholder="" /></div>
    <div>m：<el-input v-model="m" placeholder="" /></div>
    <div>d：<el-input v-model="d" placeholder="" /></div>
    <div style="margin-top: 10px;">
      <el-button @click="toCount" type="primary">计算</el-button>
      <el-button style="margin-left: 10px;" @click="toClear">清空</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
      l: '',
      e: '',
      m: '',
      d: ''
    }
  },
  methods: {
    toCount () {
      if (this.e !== '' && this.m !== '' && this.d !== '' && this.l === '') {
        this.l = 40 * Math.log10((600*3.1415) / (Math.sqrt(2*this.e*100000 / (this.m * this.d))))
      }
      if (this.e === '' && this.m !== '' && this.d !== '' && this.l !== '') {
        const gen = 600 * 3.1415 / (10 ** (this.l / 40))
        const base = gen ** 2
        this.e = base * this.m * this.d / 2 / 100000
      }
      if (this.e !== '' && this.m === '' && this.d !== '' && this.l !== '') {
        const gen = 600 * 3.1415 / (10 ** (this.l / 40))
        const base = gen ** 2
        this.m = 2 * this.e * 100000 / base / this.d
      }
      if (this.e !== '' && this.m !== '' && this.d === '' && this.l !== '') {
        const gen = 600 * 3.1415 / (10 ** (this.l / 40))
        const base = gen ** 2
        this.d = 2 * this.e * 100000 / base / this.m
      }
    },
    toClear () {
      this.l = ''
      this.e = ''
      this.m = ''
      this.d = ''
    }
  },
  mounted () {
  }

}
</script>

<style>

</style>
